import styled from 'styled-components';

export default styled.section`
  background: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.shadows.high};
  border-top: solid 5px ${props => props.theme.colors.claytonGreen};
  padding: 2rem ${props => props.theme.padding.inner} 2rem;
  margin: 4.75rem -${props => props.theme.padding.inner} 0;

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    margin: 0;
  }

  header {
    text-align: center;
  }

  > ul {
    list-style: none;
    margin: 2.5rem 0 0;
    padding: 0;

    li {
      padding: 1rem 0.75rem;

      &:nth-child(2n + 1) {
        background: ${props => props.theme.colors.claytonBlue};
        > * {
          color: ${props => props.theme.colors.white};
        }
      }

      &:nth-child(2n) {
        background: transparent;

        h4 {
          color: ${props => props.theme.colors.bedtime};
        }

        h5 {
          color: ${props => props.theme.colors.claytonBlue};
        }
      }

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        > h4 {
          max-width: 200px;
        }
      }

      > * {
        margin: 0;
      }

      h5 {
        margin: 0.5rem 0;
        text-align: right;

        span {
          display: block;
        }
      }
    }
  }
`;
